var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"yx-handle-required-page main-layout"},[_c('el-card',{staticClass:"box-form box-inner"},[_c('c-title',{attrs:{"slot":"header","title":"个人资料","back":false},slot:"header"}),_c('personal-info',{attrs:{"id":_vm.studentId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }